module.exports = __webpack_public_path__ + "img/次品总数.e625b9d3.png";